export function ApplicationHeader() {
  return null;
}

export default ApplicationHeader;
